import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@cld/component-enhancer';

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const MainLayout = ({ header, content, footer }) => {
  return (
    <Content>
      {header}
      {content}
      {footer}
    </Content>
  );
};

export default asStyledComponent(MainLayout);
